function useOnboardingContentItemProps() {
  return (article) => {
    return {
      ...article,
      action: `Click onboarding article: ${article.title}`,
      onClick: () => {
        window.open(article.url, "_blank", "noopener,noreferrer");
      },
    };
  };
}

export default useOnboardingContentItemProps;
